import {fetchRemoteResult} from "./api-util";
import securityApi from "../Util/security";

const endpoint = '/DmVisualizer/';

export default {
    listScenarios(){
        return fetchRemoteResult(`${endpoint}ListIndex`);
    },
    GetTemplatesByScenario(id) {
        return fetchRemoteResult(`${endpoint}GetScenarioTemplates/${id}`);
    },
    getCustomerContactEmail(){
        return fetchRemoteResult(`${endpoint}GetCustomerContactEmail`);
    },
    listActiveBatches(){
        return fetchRemoteResult(`${endpoint}ListActiveBatches`);
    },
    listHistoricalBatches(){
        return fetchRemoteResult(`${endpoint}ListHistoricalBatches`);
    },
    activateBatches(batchIds){
        return fetchRemoteResult(`${endpoint}ActivateBatch`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({batchIds: batchIds})
        });
    },
    deactivateBatches(batchIds){
        return fetchRemoteResult(`${endpoint}DeactivateBatch`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({batchIds: batchIds})
        });
    },
    changeInfo(model){
        return fetchRemoteResult(`${endpoint}changeInfo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    uploadLogo(logo) {
        const formData = new FormData();
        formData.append('file', logo);

        return fetchRemoteResult(`${endpoint}UploadLogo`, {
            method: 'POST',
            body: formData
        });
    },
    acceptScenarioSelection(scenarioIds){
        return fetchRemoteResult(`${endpoint}AcceptScenarioSelection`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({scenarioIds: scenarioIds})
        });
    },
    formatChangeInfoUrl(){
        return `${endpoint}ChangeInfo`;
    },
    formatTemplatesUrl(scenarioIds){
        const queryString = scenarioIds.join('&scenarioIds=', scenarioIds);
        
        return `${endpoint}Templates?scenarioIds=${queryString}`;
    },
    formatTemplatePreviewUrl(templateId){
        return `${endpoint}TemplatePreview/${templateId}`;
    },
    formatIndexUrl(){
        return `${endpoint}Index`;
    },
    validateWritePermission(){
        return this.validatePermission(
            securityApi.PermissionGrantTypes.Write
        );
    },
    validateDeletePermission(){
        return this.validatePermission(
            securityApi.PermissionGrantTypes.Delete
        );
    },
    validatePermission(permissionGrantType){
        return securityApi.validatePermission(
            securityApi.Permissions.DmVisualizer,
            permissionGrantType
        );
    },
    endpoint
};
